import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShortcut: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shortcut, hotkey, powerkey, skill"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.333 11H15.5L11 17L11.667 13H8.5L13 7L12.333 11Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShortcut;
